import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../../config';
import { useLanguage } from '../../contexts/LanguageContext';
import { User, TrainerInfo } from '../../types';
import Chat from '../messenger/Chat';
import './Trainer.css';

interface TrainerProps {
    user: User;
}

const Trainer: React.FC<TrainerProps> = ({ user }) => {
  const [trainers, setTrainers] = useState<TrainerInfo[]>([]);
  const [applicationStatus, setApplicationStatus] = useState<string | null>(null);
  const { t } = useLanguage();

  useEffect(() => {
    if (!user.trainer_id) {
      fetchAvailableTrainers();
    }
  }, [user]);

  const fetchAvailableTrainers = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/trainers/available`, { credentials: 'include' });
      const data = await response.json();
      setTrainers(data.trainers);
    } catch (error) {
      console.error('Error fetching trainers:', error);
    }
  };

  const handleApply = async (trainerId: number) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/trainer/apply/${trainerId}`, {
        method: 'POST',
        credentials: 'include'
      });
      if (response.ok) {
        setApplicationStatus('pending');
        alert('Application sent successfully!');
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.error}`);
      }
    } catch (error) {
      console.error('Error applying for training:', error);
    }
  };

  if (user.trainer) {
    return (
      <div className="trainer-dashboard">
        <div className="trainer-info-panel">
          <h1>Your Trainer</h1>
          <p><strong>Name:</strong> {user.trainer.first_name} {user.trainer.last_name}</p>
          <p><strong>Username:</strong> {user.trainer.username}</p>
          <p><strong>Email:</strong> {user.trainer.email}</p>
          
          {user.recommendations && (
            <div className="recommendations-section">
              <h2>Recommendations from your trainer:</h2>
              <p>{user.recommendations}</p>
            </div>
          )}
        </div>
        <div className="trainer-chat-panel">
          <Chat contact={user.trainer as User} currentUser={user} />
        </div>
      </div>
    );
  }

  if (applicationStatus === 'pending') {
    return (
        <div>
            <h1>Awaiting Trainer Approval</h1>
            <p>Your application is pending. You will be notified once the trainer responds.</p>
        </div>
    );
  }

  return (
    <div>
      <h1>Available Trainers</h1>
      <div className="trainers-container">
        {trainers.map((trainer) => (
          <div key={trainer.id} className="trainer-card">
            <img src={`https://i.pravatar.cc/150?u=${trainer.id}`} alt={trainer.username} className="trainer-image" />
            <div className="trainer-name">{trainer.first_name} {trainer.last_name}</div>
            <button onClick={() => handleApply(trainer.id)}>Apply</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Trainer; 